export interface RemovedRoleManagementModel {
  idList: string[];
}

export interface RoleManagementModel {
  key: string;
  id: string;
  name: string;
  normalizedName: string;
  appPermissions: AppPermissionModel[];
}

export interface CreateRoleManagementModel {
  name: string;
  appPermissions: string[];
}

export interface UpdateRoleManagementModel {
  id: string;
  name: string;
  appPermissions: string[];
}

export interface AppPermissionModel {
  id: string;
  name: string;
  groupName: string;
}

export const PermissionConst: { [key: string]: string } = {
  WEBSITE_CONTENT: "Quản lý nội dung",
  "WEBSITE_CONTENT:MANAGE": "Quản lý",

  BRANCH: "Quản lý chi nhánh",
  "BRANCH:MANAGE": "Quản lý",

  COMMENT: "Quản lý bình luận",
  "COMMENT:MANAGE": "Quản lý",

  CUSTOMER: "Quản lý khách hàng",
  "CUSTOMER:MANAGE": "Quản lý",

  PRODUCT: "Quản lý sản phẩm",
  "PRODUCT:MANAGE": "Quản lý",

  ORDER: "Quản lý bán hàng",
  "ORDER:MANAGE": "Quản lý",

  STAFF: "Quản lý nhân viên",
  "STAFF:MANAGE": "Quản lý",
};

export enum PermissionNameEnum {
  BranchManage = "BRANCH:MANAGE",
  OrderManage = "ORDER:MANAGE",
  CustomerManage = "CUSTOMER:MANAGE",
  ProductManage = "PRODUCT:MANAGE",
  StaffManage = "STAFF:MANAGE",
  WebsiteContentManage = "WEBSITE_CONTENT:MANAGE",
  CommentManage = "COMMENT:MANAGE",
}
